import React from "react";

import { ColorPicker } from "./ColorPicker";
import type { ColorModel, ColorPickerBaseProps } from "./types";
import { equalHex } from "./utils/compare";
import { hexToHsva, hsvaToHex } from "./utils/convert";

const colorModel: ColorModel<string> = {
  defaultColor: "000",
  toHsva: hexToHsva,
  fromHsva: ({ h, s, v }) => hsvaToHex({ h, s, v, a: 1 }),
  equal: equalHex,
};

const HexColorPicker = (
  props: Partial<ColorPickerBaseProps<string>>,
): JSX.Element => <ColorPicker {...props} colorModel={colorModel} />;

export default React.memo(HexColorPicker);
